// extracted by mini-css-extract-plugin
module.exports = {"container":"author_container__wrjpr","title":"author_title__T6UNg","authors":"author_authors__AeTMd","wrapper":"author_wrapper__UqrjH","photo":"author_photo__RKgrm"};